import { render } from "./EditRole.vue?vue&type=template&id=1959ab16&scoped=true"
import script from "./EditRole.vue?vue&type=script&lang=js"
export * from "./EditRole.vue?vue&type=script&lang=js"

import "./EditRole.vue?vue&type=style&index=0&id=1959ab16&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1959ab16"]])

export default __exports__